import { useEffect } from 'react';
import Nav      from './components/Nav';
import Footer   from './components/Footer';
import Marquee  from './components/Marquee';
import Hero     from './sections/Hero';
import Services from './sections/Services';
import About    from './sections/About';
import Team     from './sections/Team';
import Contact  from './sections/Contact';
import { marqueeWords, clients } from './data';

export default function App() {
  useEffect(() => {
    document.title = 'Next IT Era — Digital Agency | Dubai, UAE';
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />

        {/* Dark marquee strip */}
        <Marquee items={marqueeWords} speed={24} dark={true} />

        {/* LIGHT */}
        <Services />

        {/* DARK */}
        <About />

        {/* LIGHT */}
        <Team />

        {/* Clients — warm grey strip */}
        <div style={{ background:'#eeede9', padding:'3rem 2rem', borderTop:'1px solid rgba(12,12,10,.08)', borderBottom:'1px solid rgba(12,12,10,.08)', position:'relative', zIndex:2 }}>
          <div style={{ maxWidth:1080, margin:'0 auto' }}>
            <p style={{ textAlign:'center', fontSize:10, fontWeight:600, letterSpacing:'2px', textTransform:'uppercase', color:'rgba(12,12,10,.35)', marginBottom:'2rem' }}>
              Trusted by Great Companies
            </p>
            <Marquee items={clients} speed={32} dark={false} />
          </div>
        </div>

        {/* DARK */}
        <Contact />
      </main>
      <Footer />
    </>
  );
}
